export type SignInInitialValues = {
  email: string;
  password: string;
  passwordConfirmation: string;
};

export type ParamsType = {
  email: string;
  token: string;
  sessionId?: string;
};

export enum UpgradeType {
  ESSENTIAL = "essentials",
  CLARITY = "clarity",
  CLARITY_ADD_ON = "clarity-add-on",
  GUIDANCE = "guidance",
  GUIDANCE_ADD_ON = "guidance-add-on",
}
